<template>
  <BaseCard
    :caption-visible="false"
    :footer-visible="false"
    :actions-visible="currentUser.id === 1"
  >
    <template #title>
      <span class="h3 font-weight-bold mb-0 text-uppercase">roles</span>
    </template>
    <template #actions>
      <b-link
        v-if="currentUser.id === 1"
        v-access="{
          resource: $data.$constants.RESOURCES.RESOURCE_CONFIGURATION,
          resourceAction: $data.$constants.RESOURCE_ACTIONS.RESOURCE_ACTION_ALL
        }"
        :to="{ name: 'createRole' }"
      >
        <b-button
          variant="primary"
          class="text-nowrap rounded-sm px-2"
        >
          + Añadir rol
        </b-button>
      </b-link>
    </template>
    <RolesTable />
  </BaseCard>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseCard from '@/components/ui/card/BaseCard.vue'
import RolesTable from '@/components/role/table/RolesTable.vue'

export default {
  name: 'List',
  components: { RolesTable, BaseCard },
  computed: {
    ...mapGetters({
      currentUser: 'auth/getUser',
    }),
  }
}
</script>

<style scoped>

</style>
